import { useState, useEffect } from 'react';

const STORAGE_KEY = 'pinEnabled';

/**
 * Shared on/off switch for pinned-first sorting (see pinnedSort.js).
 * One flag for the whole app, persisted in localStorage, defaulting to on.
 */
export const usePinEnabled = () => {
  const [pinEnabled, setPinEnabled] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pinEnabled));
  }, [pinEnabled]);

  return [pinEnabled, setPinEnabled];
};

export default usePinEnabled;
